// @ services
const { get } = require('services/api');
// @ core
const apiURLBuilder = require('core/apiURLBuilder');
import { getLanguage } from 'core/i18n';
// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_RESET,
});

const hireCardImagesUpdateSelectedId = id => ({
    type: actionTypes.HIRE_CARD_IMAGE_UPDATE_SELECTED_ID,
    payload: {
        id,
    },
});

const hireCardImagesRequest = () => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_REQUEST,
});

const hireCardImagesSuccess = (images, extraImage) => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_SUCCESS,
    payload: {
        images,
        extraImage,
    },
});

const hireCardImagesFailure = error => ({
    type: actionTypes.HIRE_CARD_IMAGE_SELECTOR_FAILURE,
    payload: {
        error,
    },
});

const getHireCardImages =
    (ids, extraImage = '', isCharity = false) =>
    (dispatch, getState) => {
        if (!getState().hireCardImageSelector.get('isFetching')) {
            dispatch(hireCardImagesRequest());

            if (extraImage) {
                ids.push(extraImage);
            }

            const params = {
                header: {},
                query: {
                    channel: 'private',
                    lang: getLanguage().toLowerCase(),
                    webContentId: ids.toString(),
                },
            };

            return get(apiURLBuilder.getURL('getCMSContent'), params)
                .then(response => {
                    const nodes = response.body.data.nodes;

                    if (Array.isArray(nodes)) {
                        const responseNodes = isCharity ? nodes.slice(0).reverse() : nodes;
                        dispatch(hireCardImagesSuccess(responseNodes, extraImage));
                    }
                })
                .catch(response => {
                    if (response.error) {
                        dispatch(hireCardImagesFailure(response.error));
                    } else {
                        throw response;
                    }
                });
        }
    };

export default {
    getHireCardImages,
    hireCardImagesUpdateSelectedId,
    reset,
};
